import React from "react";
import SingleCampaignDetailed from "../../components/SingleCampaignDetailed/index";

const SingleCampaignPage = () => {

  return (
    <React.Fragment>
      <SingleCampaignDetailed />
    </React.Fragment>
  );
};

export default SingleCampaignPage;
